import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Tabs, Spin, Drawer, Tag, Space } from 'antd';
import { CheckOutlined, BellOutlined, FieldTimeOutlined, LinkOutlined } from '@ant-design/icons';
import { Cookies } from 'react-cookie';
import axios from 'axios';
import dayjs from 'dayjs';
import { isSysMessage, parseSysDiff } from '../Messages/MessageRow';

const cookies = new Cookies();
var token = cookies.get('token');

const normalizeBr = (text) => (text || '').replace(/<br\s*\/?>/gi, '\n');

const CJK_RE = /[一-鿿]/;
const initials = (name) => {
    if (!name) return '?';
    if (CJK_RE.test(name)) return name.slice(-2);
    return name.split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase();
};
const AV_COLORS = ['#3a93d6', '#7e57c2', '#26a69a', '#ef6c40', '#5c8a3a', '#c2477e'];
const avatarColor = (name) => {
    if (!name) return '#54687a';
    let h = 0; for (const c of name) h = (h * 31 + c.charCodeAt(0)) >>> 0;
    return AV_COLORS[h % AV_COLORS.length];
};

const Diff = ({ groups }) => (
    <div className="diff">
        {groups.map((g, i) => (
            <div className="grp" key={i}>
                <div className="label">修改 <span className="tag">{g.field}</span></div>
                <div className="chg">
                    {g.from ? <span className="from">{g.from}</span> : <span className="empty">（空）</span>}
                    <span className="arrow">→</span>
                    {g.to ? <span className="to">{g.to}</span> : <span className="empty">（空）</span>}
                </div>
            </div>
        ))}
    </div>
);

const sourceInfo = (type, tableId) => {
    if (type === 'home') return { label: 'AOI留言', href: '/todolist' };
    if (type === 'order') return { label: 'Order', href: `/order/${tableId}` };
    if (type === 'invoice') return { label: 'Invoice', href: `/invoice/${tableId}` };
    if (type === 'inquiry') return { label: 'Inquiry', href: `/inquiry/${tableId}` };
    return null;
};

const mapStoreToProps = (store) => {
    return {};
};

class AtmeLists extends Component {

    constructor(props) {
        super(props);
    }

    componentWillReceiveProps(nextProps) {}

    state = {
        show: false,
        processed_data: [],
        atme_data: [],
        noread_data: [],
        loading: false,
        activeTab: '1',
        noread_next_page: null,
        processed_next_page: null,
        atme_next_page: null,
        noread_loaded: false,
        processed_loaded: false,
        atme_loaded: false,
        deadlineFilterByTab: {
            '1': 'all',
            '3': 'all',
        },
        overview_loading: false,
        overview_counts: {
            pendingSoon: 0,
            pendingOverdue: 0,
            atmeSoon: 0,
            atmeOverdue: 0,
        },
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    showModal = () => {
        localStorage.setItem('atme_message_count', this.props.atme_message_count);
        this.fetchAtmeNoRead();
        this.fetchDeadlineOverview();
        this.setState({
            show: true,
            activeTab: '1',
            processed_data: [],
            atme_data: [],
            processed_next_page: null,
            atme_next_page: null,
            processed_loaded: false,
            atme_loaded: false,
        });
    }

    getDeadlineValue = (item) => {
        if (!item) return null;
        return item.deadline || item.dead_line || item.deadLine || item.due_date || item.dueDate || null;
    }

    getDeadlineAlert = (item) => {
        const deadline = this.getDeadlineValue(item);
        if (!deadline) return null;
        const dueDate = dayjs(deadline);
        if (!dueDate.isValid()) return null;
        const daysLeft = dueDate.startOf('day').diff(dayjs().startOf('day'), 'day');
        if (daysLeft < 0) {
            return {
                className: 'alert-expire',
                label: '已过期',
                deadline: dueDate.format('YYYY-MM-DD'),
            };
        }
        if (daysLeft <= 2) {
            return {
                className: 'alert-soon',
                label: `剩${daysLeft}天到期`,
                deadline: dueDate.format('YYYY-MM-DD'),
            };
        }
        return {
            className: '',
            label: '',
            deadline: dueDate.format('YYYY-MM-DD'),
        };
    }

    isHandledMessage = (item) => {
        if (!item) return false;
        const relationStatus = item.relation_description ?? item.description;
        return item.status === false || item.status === 0 || item.status === '0' || relationStatus === 1 || relationStatus === '1';
    }

    renderFormattedText = (text) => {
        if (text === null || text === undefined || text === '') return null;
        return String(text).split(/<br\s*\/?>|\r\n|\r|\n/gi).map((part, index) => (
            <React.Fragment key={index}>
                {index > 0 ? <br /> : null}
                {part}
            </React.Fragment>
        ));
    }

    changeDeadlineFilter = (tabKey, filter) => {
        this.setState((prevState) => ({
            deadlineFilterByTab: {
                ...prevState.deadlineFilterByTab,
                [tabKey]: filter,
            },
        }), () => {
            if (tabKey === '1') this.fetchAtmeNoRead(1, false);
            if (tabKey === '3') this.fetchAtMeMessage(1, false);
        });
    }

    jumpToTabWithFilter = (tabKey, filter) => {
        this.setState((prevState) => ({
            activeTab: tabKey,
            deadlineFilterByTab: {
                ...prevState.deadlineFilterByTab,
                [tabKey]: filter,
            },
        }), () => {
            if (tabKey === '1') this.fetchAtmeNoRead(1, false);
            if (tabKey === '3') this.fetchAtMeMessage(1, false);
        });
    }

    renderDeadlineFilter = (tabKey) => {
        const activeFilter = (this.state.deadlineFilterByTab && this.state.deadlineFilterByTab[tabKey]) || 'all';
        return (
            <div style={{ marginBottom: '10px' }}>
                <Space size={8} wrap>
                    <Button size="small" type={activeFilter === 'all' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'all')}>全部</Button>
                    <Button size="small" type={activeFilter === 'overdue' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'overdue')}>已过期</Button>
                    <Button size="small" type={activeFilter === 'soon' ? 'primary' : 'default'} onClick={() => this.changeDeadlineFilter(tabKey, 'soon')}>2天内到期</Button>
                </Space>
            </div>
        );
    }

    getNextPageFromUrl = (nextPageUrl) => {
        if (!nextPageUrl) return null;
        const matched = nextPageUrl.match(/[?&]page=(\d+)/);
        if (!matched) return null;
        const pageNum = parseInt(matched[1], 10);
        return Number.isNaN(pageNum) ? null : pageNum;
    }

    normalizePagedResponse = (response) => {
        const dataNode = response?.data?.data;
        if (Array.isArray(dataNode)) {
            return { items: dataNode, nextPage: null, total: dataNode.length };
        }
        if (dataNode && Array.isArray(dataNode.data)) {
            const parsedTotal = parseInt(dataNode.total, 10);
            return {
                items: dataNode.data,
                nextPage: this.getNextPageFromUrl(dataNode.next_page_url),
                total: Number.isNaN(parsedTotal) ? dataNode.data.length : parsedTotal,
            };
        }
        return { items: [], nextPage: null, total: 0 };
    }

    buildFetchUrl = (tabKey, page = 1, deadlineFilterOverride = null) => {
        const deadlineFilter = deadlineFilterOverride || ((this.state.deadlineFilterByTab && this.state.deadlineFilterByTab[tabKey]) || 'all');
        const deadlineFilterQuery = (tabKey === '1' || tabKey === '3') && deadlineFilter !== 'all'
            ? `&deadline_filter=${deadlineFilter}`
            : '';

        if (tabKey === '1') return `${window.api}admin/fetchAtme?page=${page}&no_read=1${deadlineFilterQuery}&token=${token}`;
        if (tabKey === '2') return `${window.api}admin/fetchAtme?page=${page}&token=${token}`;
        return `${window.api}admin/fetchAtMeMessage?page=${page}${deadlineFilterQuery}&token=${token}`;
    }

    fetchDeadlineOverview = () => {
        this.setState({ overview_loading: true });
        axios.get(window.api + 'admin/fetchAtmeDeadlineSummary?token=' + token)
            .then((response) => {
                const summary = response?.data?.data || {};
                const toCount = (...values) => {
                    for (let i = 0; i < values.length; i += 1) {
                        const parsed = parseInt(values[i], 10);
                        if (!Number.isNaN(parsed)) return parsed;
                    }
                    return 0;
                };

                const pendingSoon = toCount(
                    summary.pending_deadline_soon_count,
                    summary.pending_soon_count,
                    summary.initiated_deadline_soon_count,
                    summary.initiated_soon_count,
                    summary.noread_deadline_soon_count,
                    summary.noread_soon_count,
                    summary.pending?.deadline_soon_count,
                    summary.pending?.soon_count,
                    summary.initiated?.deadline_soon_count,
                    summary.initiated?.soon_count,
                );
                const pendingOverdue = toCount(
                    summary.pending_deadline_overdue_count,
                    summary.pending_overdue_count,
                    summary.initiated_deadline_overdue_count,
                    summary.initiated_overdue_count,
                    summary.noread_deadline_overdue_count,
                    summary.noread_overdue_count,
                    summary.pending?.deadline_overdue_count,
                    summary.pending?.overdue_count,
                    summary.initiated?.deadline_overdue_count,
                    summary.initiated?.overdue_count,
                );
                const atmeSoon = toCount(
                    summary.atme_deadline_soon_count,
                    summary.atme_soon_count,
                    summary.mention_deadline_soon_count,
                    summary.mention_soon_count,
                    summary.atme?.deadline_soon_count,
                    summary.atme?.soon_count,
                    summary.mention?.deadline_soon_count,
                    summary.mention?.soon_count,
                    summary.deadline_soon_count,
                    summary.soon_count,
                );
                const atmeOverdue = toCount(
                    summary.atme_deadline_overdue_count,
                    summary.atme_overdue_count,
                    summary.mention_deadline_overdue_count,
                    summary.mention_overdue_count,
                    summary.atme?.deadline_overdue_count,
                    summary.atme?.overdue_count,
                    summary.mention?.deadline_overdue_count,
                    summary.mention?.overdue_count,
                    summary.deadline_overdue_count,
                    summary.overdue_count,
                );

                this.setState({
                    overview_counts: { pendingSoon, pendingOverdue, atmeSoon, atmeOverdue },
                    overview_loading: false,
                });
            })
            .catch(() => {
                this.setState({ overview_loading: false });
            });
    }

    fetchTabData = (tabKey, page = 1, append = false) => {
        this.setState({ loading: true });
        axios.get(this.buildFetchUrl(tabKey, page))
            .then((response) => {
                const { items, nextPage } = this.normalizePagedResponse(response);
                this.setState((prevState) => {
                    if (tabKey === '1') {
                        return {
                            noread_data: append ? prevState.noread_data.concat(items) : items,
                            noread_next_page: nextPage,
                            noread_loaded: true,
                            loading: false,
                        };
                    }
                    if (tabKey === '2') {
                        return {
                            processed_data: append ? prevState.processed_data.concat(items) : items,
                            processed_next_page: nextPage,
                            processed_loaded: true,
                            loading: false,
                        };
                    }
                    return {
                        atme_data: append ? prevState.atme_data.concat(items) : items,
                        atme_next_page: nextPage,
                        atme_loaded: true,
                        loading: false,
                    };
                });
            })
            .catch((error) => {
                this.setState({ loading: false });
            });
    }

    renderPaginationFooter = (tabKey, nextPage, loaded) => {
        if (nextPage) {
            return (
                <div className="text-center" style={{ paddingTop: 12 }}>
                    <Button onClick={() => this.loadMore(tabKey)} shape="round" loading={this.state.loading}>
                        {'加载更多'}
                    </Button>
                </div>
            );
        }
        if (nextPage === null && loaded) {
            return (
                <div className="text-center" style={{ paddingTop: 12, color: 'var(--mb-text-mute, #8b99a6)', fontSize: 12 }}>
                    {'所有数据已加载完毕'}
                </div>
            );
        }
        return null;
    }

    renderDeadlineOverview = () => {
        const { overview_counts, overview_loading } = this.state;
        return (
            <div style={{
                marginBottom: '12px',
                padding: '10px 12px',
                border: '1px solid rgba(91, 192, 222, 0.45)',
                borderRadius: '8px',
                background: 'rgba(91, 192, 222, 0.10)',
            }}>
                <Spin spinning={overview_loading} size="small">
                    <div style={{ fontSize: '12px', color: '#5bc0de', marginBottom: '8px', fontWeight: 600 }}>截止提醒汇总</div>
                    <div style={{ fontSize: '12px', marginBottom: '6px' }}>
                        <span style={{ color: '#FFF' }}>发起待处理</span>
                        <Tag color="orange" style={{ marginLeft: '8px', cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('1', 'soon')}>即将 {overview_counts.pendingSoon}</Tag>
                        <Tag color="red" style={{ cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('1', 'overdue')}>已过期 {overview_counts.pendingOverdue}</Tag>
                    </div>
                    <div style={{ fontSize: '12px' }}>
                        <span style={{ color: '#FFF' }}>@我</span>
                        <Tag color="orange" style={{ marginLeft: '35px', cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('3', 'soon')}>即将 {overview_counts.atmeSoon}</Tag>
                        <Tag color="red" style={{ cursor: 'pointer' }} onClick={() => this.jumpToTabWithFilter('3', 'overdue')}>已过期 {overview_counts.atmeOverdue}</Tag>
                    </div>
                </Spin>
            </div>
        );
    }

    fetchAtmeNoRead = (page = 1, append = false) => this.fetchTabData('1', page, append);
    fetchAtme = (page = 1, append = false) => this.fetchTabData('2', page, append);
    fetchAtMeMessage = (page = 1, append = false) => this.fetchTabData('3', page, append);

    loadMore = (tabKey) => {
        if (tabKey === '1' && this.state.noread_next_page) {
            this.fetchAtmeNoRead(this.state.noread_next_page, true);
            return;
        }
        if (tabKey === '2' && this.state.processed_next_page) {
            this.fetchAtme(this.state.processed_next_page, true);
            return;
        }
        if (tabKey === '3' && this.state.atme_next_page) {
            this.fetchAtMeMessage(this.state.atme_next_page, true);
        }
    };

    handleCancel = () => this.setState({ show: false });

    onChangeTab = (key) => {
        this.setState({ activeTab: key });
        if (key === '2' && !this.state.processed_loaded) this.fetchAtme();
        if (key === '3' && !this.state.atme_loaded) this.fetchAtMeMessage();
    }

    renderItem = (e, opts = {}) => {
        const { processed = false } = opts;
        const sys = isSysMessage(e.message);
        const sysGroups = sys ? parseSysDiff(e.message) : [];

        const deadlineAlert = this.getDeadlineAlert(e);
        const isHandled = this.isHandledMessage(e) || processed || !e.status;

        const src = sourceInfo(e.type, e.table_1);

        const timeStr = e.created_at || '';
        const processedTimeStr = e.updated_at || '';

        const sourceChip = src ? (
            <a className="source-chip" href={src.href} target="_blank" rel="noopener noreferrer">
                <LinkOutlined style={{ fontSize: 10 }} /> {src.label}
            </a>
        ) : null;

        const doneChip = isHandled ? (
            <span className="status-chip done"><CheckOutlined style={{ fontSize: 10 }} /> 已处理</span>
        ) : null;

        const metaSub = (() => {
            const hasNotice = e.notices;
            const hasDeadline = !!(deadlineAlert && deadlineAlert.deadline);
            const hasProcessedTime = processed && processedTimeStr;
            if (!hasNotice && !hasDeadline && !hasProcessedTime) return null;
            return (
                <div className="meta-sub">
                    {hasNotice ? <span className="notice"><BellOutlined /> {this.renderFormattedText(e.notices)}</span> : null}
                    {hasDeadline ? (
                        <span className="deadline">
                            <FieldTimeOutlined /> 截止 {deadlineAlert.deadline}
                            {!isHandled && deadlineAlert.className ? <span className={deadlineAlert.className} style={{ marginLeft: 6 }}>· {deadlineAlert.label}</span> : null}
                        </span>
                    ) : null}
                    {hasProcessedTime ? <span className="deadline"><CheckOutlined /> 处理 {processedTimeStr}</span> : null}
                </div>
            );
        })();

        if (sys) {
            return (
                <div className="m sys" key={`${e.id || ''}-${e.created_at || ''}`}>
                    <span className="node" />
                    <div className="sys-line">
                        <span className="who">{e.user_name}</span>
                        <span>修改了 · {timeStr}</span>
                        <span className="spacer" style={{ flex: 1 }} />
                        {doneChip}
                        {sourceChip}
                    </div>
                    {sysGroups.length > 0
                        ? <Diff groups={sysGroups} />
                        : <div className="sys-text">{normalizeBr(e.message)}</div>}
                </div>
            );
        }

        return (
            <div className={`m human ${isHandled ? 'done' : ''}`} key={`${e.id || ''}-${e.created_at || ''}`}>
                <span className="node" />
                <div className="avatar" style={{ background: avatarColor(e.user_name) }}>{initials(e.user_name)}</div>
                <div className="body">
                    <div className="mhead">
                        <span className="who">{e.user_name}</span>
                        <span className="when">{timeStr}</span>
                        {doneChip}
                        <span className="spacer" />
                        {sourceChip}
                    </div>
                    <div className="bubble">
                        {e.message ? (
                            <div className="content" style={isHandled ? { opacity: .68 } : null}>
                                {this.renderFormattedText(e.message)}
                            </div>
                        ) : null}
                        {metaSub}
                    </div>
                </div>
            </div>
        );
    }

    renderList = (items, loaded, emptyText, opts) => {
        if (items.length === 0 && loaded) {
            return <div className="thread-empty">{emptyText || '当前筛选下没有留言'}</div>;
        }
        return (
            <div className="mb mb-flush" data-density="compact">
                <div className="thread v-chat">
                    {items.map(item => this.renderItem(item, opts))}
                </div>
            </div>
        );
    }

    render() {
        return (
            <Drawer
                destroyOnClose
                title="留言"
                placement="right"
                closable={false}
                open={this.state.show}
                onClose={this.handleCancel}
                width={'460px'}
            >
                {this.renderDeadlineOverview()}
                <Tabs size="small" tabBarGutter={8} activeKey={this.state.activeTab} onChange={this.onChangeTab} items={[
                    {
                        key: '1',
                        label: '发起待处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.renderDeadlineFilter('1')}
                            {this.renderList(this.state.noread_data, this.state.noread_loaded, '当前筛选下没有留言')}
                            {this.renderPaginationFooter('1', this.state.noread_next_page, this.state.noread_loaded)}
                        </>,
                    },
                    {
                        key: '2',
                        label: '发起已处理',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.renderList(this.state.processed_data, this.state.processed_loaded, '没有已处理留言', { processed: true })}
                            {this.renderPaginationFooter('2', this.state.processed_next_page, this.state.processed_loaded)}
                        </>,
                    },
                    {
                        key: '3',
                        label: '@我',
                        children: <>
                            <Spin spinning={this.state.loading} tip="Loading"></Spin>
                            {this.renderDeadlineFilter('3')}
                            {this.renderList(this.state.atme_data, this.state.atme_loaded, '当前筛选下没有留言')}
                            {this.renderPaginationFooter('3', this.state.atme_next_page, this.state.atme_loaded)}
                        </>,
                    },
                ]} />
            </Drawer>
        );
    }
}

export default connect(mapStoreToProps)(AtmeLists);
